import { Component, OnInit } from '@angular/core';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { api } from 'src/app/@shared/services/api';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-rules',
  templateUrl: './rules.component.html',
  styleUrls: ['./rules.component.css']
})
export class RulesComponent implements OnInit {
  public api = api;
  public env = environment;
  public data:any;
  constructor(public service: WebserviceService) { }

  ngOnInit(): void {
    this.getData();
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  getData() {
    this.getServices().Get(`${this.env.baseUrl + this.api.rules}`).subscribe(
      (res) => {
        if (res.status == true) {
          this.data = res.data.rules != null ? res.data.rules : '<p></p>';
        }
      },
      (err) => {
        console.log(err);
      });
  }

  trackByIndex(index: number, obj: any): any {
    return index;
  }

}
